// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"kF","modalBox":"kF","modal-mask":"kG","modalMask":"kG","close-btn":"kH","closeBtn":"kH","container":"kI","content":"kJ","title":"kK","subTitle":"kL","detail":"kM"};